module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_Vitra02.0114.png.09d504f6.jpg";